namespace TabAurous.Master {
    export interface CamlyticsRow {
        Id?: number;
        CompanyId?: number;
        Url?: string;
        ChannelId?: string;
    }

    export namespace CamlyticsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Url';
        export const localTextPrefix = 'Master.Camlytics';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            CompanyId = "CompanyId",
            Url = "Url",
            ChannelId = "ChannelId"
        }
    }
}
